<template>
  <div class="common-box admin-user-management">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="所属部门：" prop="departmentId" class="mr0">
              <el-select
                size="mini"
                v-model="form.departmentId"
                filterable
                placeholder="请选择所属部门"
                clearable
                reserve-keyword
                :remote="true"
                :remote-method="searchDepartmentList"
                @visible-change="searchDepartmentList('')"
                @change="handleSearchListData"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.departmentName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号：">
              <el-input
                @change="handleSearchListData"
                size="mini"
                v-model.trim="form.phone"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名：">
              <el-input
                @change="handleSearchListData"
                size="mini"
                v-model.trim="form.nickname"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select
                size="mini"
                clearable
                v-model="form.status"
                @change="handleSearchListData"
              >
                <el-option
                  v-for="item in statusArray"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['RWZPTJ']"
          class="plr28"
          @click="handleAdd"
          >添加</el-button
        >
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['RWZPSC']"
          @click="deleteAssignMore"
          class="plr28"
          plain
          >删除</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="phone"
            label="登陆账号"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="nickname"
            label="姓名"
            width="100"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="departmentName"
            label="所属部门"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftLocation"
            label="电梯位置"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="startTime"
            width="100"
            label="开始时间"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="endTime"
            width="100"
            label="结束时间"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="status"
            width="100"
            label="状态"
          >
            <template slot-scope="scope">{{
              scope.row.status == 1 ? "启用" : "禁用"
            }}</template>
          </el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['RWZPBJ']"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <div class="btn-divide" v-if="hasRole['RWZPBJ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['RWZPSC']"
                type="text"
                @click="deleteAssign(scope.row)"
                >删除</el-button
              >
              <div class="btn-divide" v-if="hasRole['RWZPSC']"></div>
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['RWZPZT']"
                @click="handleType(scope.row)"
                >{{ scope.row.status == 1 ? "禁用" : "激活" }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-assigne
      v-if="addAssignVisible"
      :editData="assignDetail"
      @cancel="addAssignVisible = false"
      @confirm="handleAaddAssignConfirm"
    ></add-assigne>
  </div>
</template>

<script>
import { getDepartmentSimpleList } from "@/api/UserManagement";
import AddAssigne from "./components/AddAssigne";
import {
  getAssignPageList,
  deleteAssign,
  changeAssignStatus,
} from "@/api/TaskAssigned";
export default {
  name: "TaskAssigned",
  components: {
    AddAssigne,
  },
  data() {
    return {
      form: {
        departmentId: "",
        nickname: "",
        phone: "",
        status: "",
        departmentName: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addAssignVisible: false,
      assignDetail: {},
      userId: "",
      statusArray: [
        { dictionaryValue: "激活", dictionaryCode: 1 },
        { dictionaryValue: "启用", dictionaryCode: 2 },
      ],
      departmentList: [],
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    async searchDepartmentList(keyword) {
      const res = await getDepartmentSimpleList({
        keyword: keyword,
        size: 100,
        unitId: "",
      });
      if (res.code === 200) {
        this.departmentList = res.data;
      }
    },
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      const params = await this.getParams();
      const res = await getAssignPageList(params);
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAdd() {
      this.assignDetail = null;
      this.addAssignVisible = true;
    },
    handleEdit(row) {
      this.assignDetail = {...row};
      this.addAssignVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAaddAssignConfirm() {
      this.addAssignVisible = false;
      this.getListData();
    },
    deleteAssignMore(row) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的任务");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteAssign({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteAssign(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteAssign({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleType(row) {
      let message = "";
      if (row.status == 1) {
        message = "是否禁用？";
      } else {
        message = "是否启用？";
      }
      this.$confirm(message, "修改状态", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await changeAssignStatus({
            idList: [row.id],
            status: row.status == 1 ? 2 : 1,
          });
          if (res.code === 200) {
            this.$message.success((row.status == 1 ? "禁用" : "启用") + "成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.admin-user-management {
  .checkbox-group-box {
    .el-form-item__content {
      width: 515px;
    }
  }
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/TaskAssigned/TaskAssigned.vue